import * as Api from "@api";
import * as C from "@components";
import clsx from "clsx";
import React from "react";
import css from "./power-pulse.card.module.scss";

export const PowerPulseCardContentKeys = [
    "power-pulse.headline",
    "power-pulse.body",
] as const;

export const enum PowerPulseCardVariant
{
    W100Left,
    W40Bottom,
    W60Bottom,
    SmallAnimation
}

interface PowerPulseCardProps
{
    pageContent: Api.Content<typeof PowerPulseCardContentKeys[number]>;
    variant: PowerPulseCardVariant;
    textMaxWidth?: C.Width;
    className?: string;
    srcAnimation?: string;
}

export const PowerPulseCard = ({ pageContent, textMaxWidth, variant, className, srcAnimation }: PowerPulseCardProps): React.FunctionComponentElement<PowerPulseCardProps> =>
{
    const classes = clsx(
        css["card"],
        {
            [css["card--w100-left"]]: variant === PowerPulseCardVariant.W100Left,
            [css["card--w40-top"]]: variant === PowerPulseCardVariant.W40Bottom,
            [css["card--w60-bottom"]]: variant === PowerPulseCardVariant.W60Bottom,
            [css["card--small-animation"]]: variant === PowerPulseCardVariant.SmallAnimation,
        },
        className
    );

    const ipadWidth = (variant === PowerPulseCardVariant.W40Bottom || variant === PowerPulseCardVariant.SmallAnimation)
        ? C.Width.W40P : variant === PowerPulseCardVariant.W60Bottom ? C.Width.W60P : undefined;
    const textCentered = variant === PowerPulseCardVariant.W40Bottom
        || variant === PowerPulseCardVariant.W60Bottom
        || variant === PowerPulseCardVariant.SmallAnimation;

    return (
        <C.Card className={classes} layout={{ all: { width: C.Width.W100P }, ipad: { width: ipadWidth } }} useWrapper>
            <C.PageContentBlock
                keys={PowerPulseCardContentKeys}
                pageContent={pageContent}
                items={{
                    "power-pulse.headline": { props: { centered: textCentered, typography: C.Typography.H3, margins: { bottom: C.Margin.D20 }, maxWidth: textMaxWidth } },
                    "power-pulse.body": { props: { centered: textCentered, typography: C.Typography.P2, margins: { bottom: C.Margin.D20 }, maxWidth: textMaxWidth } }
                }}
            />
            <div className={css["power-pulse-video"]}>
                <C.InplaceVideo autoPlay loop muted>
                    <source src={srcAnimation ?? `/video/power-pulse.mp4`} type="video/mp4" />
                </C.InplaceVideo>
            </div>
        </C.Card>
    );
}